import * as APPCONFIG from "../config/app-config.js";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

class ChatService {
  saveChat(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/savechat`,
      data: formValues,
    });
  }

  getChatistbyId(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getMessagebyid`,
      data: formValues,
    });
  }


   getUserForGroupChat(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getUsersForGroupChat`,
      data: formValues,
    });
  }

   createGroupChat(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.CHAT_URL}api/createGroup`,
      data: formValues,
    });
  }

  getGroupsByMemberId(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.CHAT_URL}api/getGroupsByMemberId`,
      data: formValues,
    });
  }


    getGroupMessages(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.CHAT_URL}api/getGroupMessages`,
      data: formValues,
    });
  }
  
}

export default new ChatService();
